module.exports = __webpack_public_path__ + "static/img/kjdy16.4b3a9a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy16.png
// module id = 331
// module chunks = 0